import get from 'lodash/get';
export default function injectDynamicAdContent(divContainer, adContent, width, height) {
    const outdatedContent = divContainer.firstChild;
    if (outdatedContent) {
        divContainer.removeChild(outdatedContent);
    }
    const div = document.createElement('div');
    const iframe = document.createElement('iframe');
    iframe.src = 'about:blank';
    iframe.style.display = 'inline-block';
    iframe.style.width = `${width}px`;
    iframe.style.height = `${height}px`;
    div.appendChild(iframe);
    divContainer.appendChild(div);
    const iFrameDocument = iframe.contentWindow?.document;
    const content = `<body style="margin: 0">${adContent}</body>`;
    iFrameDocument.open();
    iFrameDocument.write(content);
    iFrameDocument.close();
    return get(iframe, 'contentWindow.document.body');
}
